import { render, staticRenderFns } from "./loading-message.vue?vue&type=template&id=8abcd150"
import script from "./loading-message.vue?vue&type=script&lang=js"
export * from "./loading-message.vue?vue&type=script&lang=js"
import style0 from "./loading-message.vue?vue&type=style&index=0&id=8abcd150&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports